<form [formGroup]="rejectForm" class="reject-order-form" (ngSubmit)="reject()">
  <h2>Reject Order Request</h2>

  <div class="order-info">
    <p>
      <span class="label">Patient:</span>
      <span class="value"
        >{{ data?.request_body?.patient?.firstName }} {{ data?.request_body?.patient?.lastName }}</span
      >
    </p>
    <p>
      <span class="label">Device:</span>
      <span class="value">{{ data?.request_body?.device?.sku_name || data?.request_body?.device?.sku_display }}</span>
    </p>
    <p *ngIf="data?.request_body?.supply_name">
      <span class="label">Supply:</span>
      <span class="value">{{ data?.request_body?.supply_name }}</span>
    </p>
    <div class="reason-container">
      <mat-form-field appearance="outline" class="reason-form-field">
        <mat-label>Reason for Rejection</mat-label>
        <mat-select formControlName="reason">
          <mat-option *ngFor="let option of rejectOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="rejectForm.get('reason')?.value === 'Other'">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Reason</mat-label>
          <textarea
            matInput
            formControlName="otherReason"
            placeholder="Please provide a reason for rejecting this order request"
            rows="5"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="reject-order-buttons" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="1rem">
    <button mat-raised-button color="default" type="button" (click)="cancel()" [disabled]="showProgressBar">
      Cancel
    </button>
    <button mat-raised-button color="warn" type="submit" [disabled]="showProgressBar || rejectForm.invalid">
      Reject Order
    </button>
    <mat-spinner [diameter]="20" *ngIf="showProgressBar"></mat-spinner>
  </div>
</form>
